module.exports = __webpack_public_path__ + "img/table-layout.64fc6918.svg";